module.exports = __webpack_public_path__ + "baded94134f273450a473a4962111324.ttf";